import React, { useState } from 'react'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import { errorToast, successToast } from 'src/utils/toastService'
import { useAddBranchGymMutation } from 'src/api/branchGymApi'

export type IFormInput = {
  name: string
  about: string
  address: string
  latitude: number
  longitude: number
  rating: number
  parentGym: { label: string; value: number }
  open: string
  close: string
}

export const formSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  about: Yup.string().required('About Gym is required'),
  address: Yup.string().required('Address is required'),
  // latitude: Yup.number().required('Latitude is required').min(1,'Latitude is required'),
  // longitude: Yup.number().required('Longitude is required').min(1,'Longitude is required'),
  latitude: Yup.number().required('Latitude is required'),
  longitude: Yup.number().required('Longitude is required'),
  rating: Yup.number().required('Rating is required').min(1),
  parentGym: Yup.object()
    .shape({
      label: Yup.string().required('Parent Gym is required'),
      value: Yup.number().required('Parent Gym is required').min(1,'Parent Gym is required'),
    })
    .required('Parent Gym is required '),
  open: Yup.string().required('Open timing is required'),
  close: Yup.string().required('Close timing is required'),
})

type useAddBranchGymProps = {
  successCallback: () => void
}
const useAddBranchGym = ({ successCallback }: useAddBranchGymProps) => {
  const [file, setFile] = useState<File | null>(null)
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'all',
    defaultValues: {
      name: '',
      about: '',
      address: '',
      latitude: 0,
      longitude: 0,
      rating: 0,
      parentGym: {label:'Choose Parent Gym', value: 0},
      open: '',
      close: '',
    },
  })
  const [addBranchGym, { isLoading: isLoadingAddBranchGym }] = useAddBranchGymMutation()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setFile(e.target.files[0])
    }
  }

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log(data, file)
    if (!file) {
      errorToast('Gym image is required.')
      return
    }
    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('about', data.about)
    formData.append('address', data.address)
    formData.append('latitude', data.latitude.toString())
    formData.append('longitude', data.longitude.toString())
    formData.append('rating', data.rating.toString())
    formData.append('parent_gym_id', data.parentGym.value.toString())
    formData.append('opened_at', data.open.toString())
    formData.append('closed_at', data.close.toString())
    formData.append('picture', file)
    addBranchGym(formData)
      .unwrap()
      .then((res) => {
        console.log(res)
        successToast('Gym added successfully.')
        reset()
        setFile(null)
        successCallback()
      })
      .catch((err) => {
        console.log(err)
        errorToast('Unable to add Gym.')
      })
  }

  return {
    file,
    handleFileChange,
    onSubmit: handleSubmit(onSubmit),
    control,
    errors,
    isLoadingAddBranchGym,
  }
}

export default useAddBranchGym
